(function(){
  "use strict";

  function formatMoney(cents, format){
    if(typeof cents !== "number") cents = parseInt(cents, 10) || 0;
    format = format || "AED {{amount}}";
    var value2 = (cents / 100).toFixed(2);
    var parts = value2.split(".");
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];
    var noDecimals = Math.round(cents / 100).toString();
    return format
      .replace("{{amount_with_comma_separator}}", withComma)
      .replace("{{amount_no_decimals}}", noDecimals)
      .replace("{{amount}}", value2);
  }

  document.querySelectorAll("[data-builder]").forEach(function(root){
    var variantsEl = root.querySelector("[data-builder-variants]");
    if(!variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch(e){ return; }

    var moneyFormat = root.getAttribute("data-money-format") || "AED {{amount}}";
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll("[data-option-position]"));
    var form = root.querySelector("[data-builder-form]");
    var addToCartBtn = root.querySelector("[data-add-to-cart]");
    var priceEl = root.querySelector("[data-builder-price]");
    var comparePriceEl = root.querySelector("[data-builder-compare-price]");
    var totalPriceEl = root.querySelector("[data-builder-total-price]");
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var frameImg = root.querySelector("[data-builder-image]");
    var roseMark = root.querySelector("[data-builder-fallback]");
    var frameTag = root.querySelector("[data-builder-frametag]");
    var summaryLine = root.querySelector("[data-builder-summary]");
    var colourSelectedEl = root.querySelector("[data-builder-colour-selected]");
    var errorEl = root.querySelector("[data-builder-error]");
    var viewBagLink = root.querySelector("[data-view-bag]");
    var stemsUnit = root.getAttribute("data-stems-unit") || "Stems";

    var labels = {
      idle: addToCartBtn ? addToCartBtn.getAttribute("data-label-add") : "Add to Bag",
      adding: addToCartBtn ? addToCartBtn.getAttribute("data-label-adding") : "Adding…",
      added: addToCartBtn ? addToCartBtn.getAttribute("data-label-added") : "Added",
      soldOut: addToCartBtn ? addToCartBtn.getAttribute("data-label-soldout") : "Sold Out",
      unavailable: addToCartBtn ? addToCartBtn.getAttribute("data-label-unavailable") : "Unavailable"
    };

    var variantMap = {};
    variants.forEach(function(v){
      var key = [v.option1, v.option2, v.option3].join("___");
      variantMap[key] = v;
    });

    var selections = optionGroups.map(function(group){
      var active = group.querySelector(".active[data-value]");
      return active ? active.getAttribute("data-value") : null;
    });

    function currentVariant(){
      return variantMap[selections.join("___")] || null;
    }

    function updateAvailability(){
      optionGroups.forEach(function(group, idx){
        var buttons = group.querySelectorAll("[data-value]");
        buttons.forEach(function(btn){
          var testSelections = selections.slice();
          testSelections[idx] = btn.getAttribute("data-value");
          var key = testSelections.join("___");
          var match = variantMap[key];
          var exists = !!match;
          var available = match ? match.available : false;
          btn.classList.toggle("unavailable-combo", !exists || !available);
        });
      });
    }

    function selectedAddons(){
      return Array.prototype.slice.call(root.querySelectorAll(".addon-chip.active"));
    }

    function updatePricing(variant){
      var base = variant ? variant.price : null;
      if(priceEl && base !== null){
        priceEl.textContent = formatMoney(base, moneyFormat);
      }
      if(comparePriceEl){
        if(variant && variant.compare_at_price && variant.compare_at_price > variant.price){
          comparePriceEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if(totalPriceEl){
        var total = base || 0;
        selectedAddons().forEach(function(chip){
          total += parseInt(chip.getAttribute("data-addon-price") || "0", 10);
        });
        totalPriceEl.textContent = formatMoney(total, moneyFormat);
      }
    }

    function updateSummary(variant){
      var colourIdx = optionGroups.findIndex(function(g){ return g.getAttribute("data-option-role") === "colour"; });
      var pkgIdx = optionGroups.findIndex(function(g){ return g.getAttribute("data-option-role") === "package"; });
      var stemsIdx = optionGroups.findIndex(function(g){ return g.getAttribute("data-option-role") === "stems"; });
      var colourName = colourIdx > -1 ? selections[colourIdx] : "";
      var pkgName = pkgIdx > -1 ? selections[pkgIdx] : "";
      var stemsVal = stemsIdx > -1 ? selections[stemsIdx] : "";

      var line = [stemsVal, stemsUnit].filter(Boolean).join(" ") + " · " + colourName + " · " + pkgName;
      var addonNames = selectedAddons().map(function(c){ return c.getAttribute("data-addon-name"); });
      if(addonNames.length) line += " + " + addonNames.join(" + ");

      if(summaryLine) summaryLine.textContent = line;
      if(frameTag) frameTag.textContent = line;
      if(colourSelectedEl) colourSelectedEl.textContent = colourName;
    }

    function sizedImageUrl(src, width){
      if(!src) return src;
      var sep = src.indexOf("?") > -1 ? "&" : "?";
      return src + sep + "width=" + width;
    }

    function updateImage(variant){
      if(!frameImg) return;
      var src = variant && variant.featured_image ? variant.featured_image.src : root.getAttribute("data-fallback-image");
      if(src){
        frameImg.src = sizedImageUrl(src, 800);
        frameImg.hidden = false;
        if(roseMark) roseMark.hidden = true;
      } else {
        frameImg.hidden = true;
        if(roseMark) roseMark.hidden = false;
      }
    }

    function updateAddToCartState(variant){
      if(!addToCartBtn) return;
      if(!variant){
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = labels.unavailable;
      } else if(!variant.available){
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = labels.soldOut;
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = labels.idle;
      }
    }

    function sync(){
      var variant = currentVariant();
      if(idInput && variant) idInput.value = variant.id;
      updatePricing(variant);
      updateSummary(variant);
      updateImage(variant);
      updateAvailability();
      updateAddToCartState(variant);
      if(errorEl) errorEl.hidden = true;
    }

    optionGroups.forEach(function(group, idx){
      group.addEventListener("click", function(evt){
        var btn = evt.target.closest("[data-value]");
        if(!btn || !group.contains(btn)) return;
        evt.preventDefault();
        group.querySelectorAll("[data-value]").forEach(function(b){ b.classList.remove("active"); });
        btn.classList.add("active");
        selections[idx] = btn.getAttribute("data-value");
        sync();
      });
    });

    root.querySelectorAll(".addon-chip").forEach(function(chip){
      chip.addEventListener("click", function(){
        chip.classList.toggle("active");
        sync();
      });
    });

    if(form){
      form.addEventListener("submit", function(evt){
        evt.preventDefault();
        var variant = currentVariant();
        if(!variant || !variant.available || !addToCartBtn) return;

        var items = [{id: variant.id, quantity: 1}];
        selectedAddons().forEach(function(chip){
          var addonId = chip.getAttribute("data-addon-variant-id");
          if(addonId) items.push({id: parseInt(addonId, 10), quantity: 1});
        });

        addToCartBtn.disabled = true;
        addToCartBtn.textContent = labels.adding;
        if(errorEl) errorEl.hidden = true;

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js", {
          method: "POST",
          headers: {"Content-Type": "application/json", "Accept": "application/json"},
          body: JSON.stringify({items: items})
        })
        .then(function(r){ return r.json().then(function(data){ return {ok: r.ok, data: data}; }); })
        .then(function(res){
          if(!res.ok){
            throw new Error(res.data && res.data.description ? res.data.description : "Error adding to cart");
          }
          addToCartBtn.textContent = labels.added;
          if(viewBagLink) viewBagLink.hidden = false;
          if(window.MrRoses && window.MrRoses.refreshCartCount) window.MrRoses.refreshCartCount();
          setTimeout(function(){
            var v = currentVariant();
            updateAddToCartState(v);
          }, 2200);
        })
        .catch(function(err){
          if(errorEl){
            errorEl.textContent = err.message;
            errorEl.hidden = false;
          }
          var v = currentVariant();
          updateAddToCartState(v);
        });
      });
    }

    sync();
  });
})();
